import React from 'react';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import RecommendationIcon from '../../media/RecommendationIcon.svg';
import ScheduledIcon from '../../media/Coupon_step2_Scheduled_Illustration.svg';
import CouponIcon from '../../media/CouponIcon.svg';

const merchantcenterLink = `${location.origin}/campaign/vnext/merchantcenter${location.search}`;

export const getFACShoppingCampaignSteps = (i18n) => ([
  {
    stepIndex: 1,
    icon: RecommendationIcon,
    description: <ReactTemplate
      model={{ link: text => <a href={merchantcenterLink}>{text}</a> }}
      template={i18n.getString('Coupon_LightboxStep1Description_Shopping_Campaign')}
    />,
  }, {
    stepIndex: 2,
    icon: ScheduledIcon,
    description: i18n.getString('Coupon_LightboxStep2Description_Shopping_Campaign'),
  }, {
    stepIndex: 3,
    icon: CouponIcon,
    description: i18n.getString('Coupon_LightboxStep3Description_Shopping_Campaign'),
  },
]);
